var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.956 3c1.013 0 1.703 1.082 1.696 2.229l1.587 10.059h.02v.119l.094.602.035.222-.119.19-.01.016v.052l-.033-.001-.125.201c-1.55 2.45-2.425 3.511-3.145 3.511H5.045c-.773 0-1.662-1.264-3.318-4.282l-.1-.182.034-.204 1.68-10.21C3.342 4.082 4.033 3 5.046 3h11.911zm1.847 13.49-3.407-.001a.705.705 0 0 1-.088.076l-2.19 1.6a.7.7 0 0 1-.414.135H8.98a.7.7 0 0 1-.448-.162l-1.92-1.6-.052-.05-3.134.003c.377.653.708 1.188.99 1.604l.115.167c.214.304.393.527.531.663.064.063.083.075-.017.075h11.911c-.06 0 .197-.223.54-.65.352-.44.789-1.06 1.307-1.86zm-5.088-.002h-5.6l.974.812 3.517-.001 1.11-.811zM16.956 4.2H5.045c-.208 0-.503.463-.511 1.22l-1.618 9.868h16.108L17.46 5.322c0-.609-.251-1.05-.453-1.114l-.05-.008zm-3.946 7.202a.5.5 0 1 1-.435.9 3.94 3.94 0 0 0-3.39-.024.5.5 0 0 1-.423-.906 4.94 4.94 0 0 1 4.248.03zm1.447-1.75a.5.5 0 0 1-.501.866 6.167 6.167 0 0 0-5.712-.257.5.5 0 1 1-.423-.906 7.167 7.167 0 0 1 6.636.297zm1.054-2.214a.5.5 0 0 1-.537.844c-2.285-1.453-5.89-1.453-8.07-.006a.5.5 0 0 1-.552-.833c2.51-1.667 6.543-1.667 9.159-.005z",
    fill: "#1E96A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }))));
};

export default SvgScale;